import { render, staticRenderFns } from "./bgShape.vue?vue&type=template&id=f90c36b4&scoped=true&"
import script from "./bgShape.vue?vue&type=script&lang=js&"
export * from "./bgShape.vue?vue&type=script&lang=js&"
import style0 from "./bgShape.vue?vue&type=style&index=0&id=f90c36b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90c36b4",
  null
  
)

export default component.exports